import { FiPhoneCall } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import React from 'react';
import Logo from '../../assets/logo_2x.png';

const Footer = () => {
  return (
    <footer className='relative bg-[#fff]'>
      {/* Top Section */}
      <div className='relative overflow-x-hidden pb-[270px]'>
        <div className='mt-6'>
          <div className='px-4 lg:px-16'>
            <div className='mx-auto grid grid-cols-1 gap-10 text-[#3F5F7D] md:grid-cols-2 lg:grid-cols-5'>
              {/* Logo + Description */}
              <div>
                <img
                  src={Logo}
                  alt='BlueLagoon Travels'
                  className='mb-4 h-20 w-auto'
                />
                <p className='font-semibold'>
                  At <span className='font-semibold'>BlueLagoon Travels</span>, we believe that
                  travel is not just about visiting new places—it’s about creating unforgettable
                  experiences and memories.
                </p>
              </div>

              {/* Company */}
              <div>
                <h3 className='mb-6 text-lg font-semibold'>Company</h3>
                <ul className='space-y-3'>
                  <li>
                    <Link
                      to='/'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/about-us'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      About Us
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/services'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Services
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/contact-us'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/testimonials'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Client Review
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Services */}
              <div>
                <h3 className='mb-6 text-lg font-semibold'>Services</h3>
                <ul className='space-y-3'>
                  <li>
                    <Link
                      to='/service/book-hotel-resorts'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Book Hotel & Resorts
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/service/corporate-travels'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Corporate Travels
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/service/flights'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Flights
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/service/travel-insurance'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Travel Insurance
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/service/visa'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Visa
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/service/forex'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Forex
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Tours */}
              <div>
                <h3 className='mb-6 text-lg font-semibold'>Tours</h3>
                <ul className='space-y-3'>
                  <li>
                    <Link
                      to='/domestic'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      Domestic
                    </Link>
                  </li>
                  <li>
                    <Link
                      to='/international'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      International
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Contact Info */}
              <div>
                <h3 className='mb-6 text-lg font-semibold'>Contact Info</h3>
                <ul className='space-y-3'>
                  <li className='flex items-center gap-3'>
                    <FiPhoneCall />
                    <a
                      href='tel:+917573035965'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      +91 7573035965
                    </a>
                  </li>
                  <li className='flex items-center gap-3'>
                    <FiPhoneCall />
                    <a
                      href='tel:+919429620999'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      +91 9429620999
                    </a>
                  </li>
                  <li className='flex items-center gap-3'>
                    <i className='far fa-envelope'></i>
                    <a
                      href='mailto:info@bluelagoontravels.com'
                      className='font-semibold hover:text-[#495BFF]'
                    >
                      info@bluelagoontravels.com
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Background animations */}
        <div className='footer_bg'>
          <div className='footer_bg_one'></div>
          {/* <div className="footer_bg_two"></div> */}
        </div>
      </div>

      {/* Bottom Section */}
      <div className='border-t border-gray-200 py-6'>
        <div className='container mx-auto flex flex-col items-center justify-between px-4 font-semibold text-[#3F5F7D] md:flex-row'>
          <p>© {new Date().getFullYear()} Bluelagoon Travels. All rights reserved.</p>
          <p className='mt-2 font-semibold md:mt-0'>
            Designed and Developed <i className='icon_heart text-red-500'></i> By{' '}
            <a
              href='http://anaxistech.com'
              target='_blank'
              rel='noopener noreferrer'
              className='font-bold text-[#495BFF]'
            >
              Anaxistech
            </a>
          </p>
        </div>
      </div>

      {/* Animation Keyframes */}
      <style jsx>{`
        @keyframes slide {
          0% {
            left: -25%;
          }
          100% {
            left: 100%;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;
